/*
 * Copyright (c) 2017-present, flop! contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 * https://framagit.org/flopedt/flopedt
 */

import type { BodyOf, ResponseOf } from './core/schema.utils.d.ts'

import { Department } from '../entities/department.ts'
import { del, get, patch, post } from './core/http.ts'

export type APIAllDepartmentsData = ResponseOf<'v1/departments/', 'get', 200>

export type APIDepartmentData = ResponseOf<'v1/departments/{dept_id}/', 'get', 200>

export type APICreateDepartmentParams = BodyOf<'v1/departments/', 'post'>
export type APICreateDepartmentData = ResponseOf<'v1/departments/', 'post', 201>

export type APIUpdateDepartmentParams = BodyOf<'v1/departments/{dept_id}/', 'patch'>
export type APIUpdateDepartmentData = ResponseOf<'v1/departments/{dept_id}/', 'patch', 200>

export async function getAllDepartments() {
  const departments = await get<APIAllDepartmentsData>('/api/v1/departments/')
  return departments.map((d) => Department.fromJSON(d))
}

export async function getDepartment(id: number) {
  const department = await get<APIDepartmentData>(`/api/v1/departments/${id}/`)
  return Department.fromJSON(department)
}

export async function createDepartment(data: APICreateDepartmentParams) {
  const department = await post<APICreateDepartmentData>(`/api/v1/departments/`, data)
  return Department.fromJSON(department)
}

export async function updateDepartment(id: number, data: APIUpdateDepartmentParams) {
  const department = await patch<APIUpdateDepartmentData>(`/api/v1/departments/${id}/`, data)
  return Department.fromJSON(department)
}

export async function deleteDepartment(id: number) {
  await del(`/api/v1/departments/${id}/`)
}
